import {Provider} from 'react-redux'
import store from '../shared/data/store'
import ChatUI from './chat_ui'

export default () => (
  <Provider store={store}>
    <ChatUI />
  </Provider>
)



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/index.js
 **/